import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------ *\
  #TABS
\* ------------------------------------ */
/**
 * Component typography presets
 */
.cat-c-tabs--full-width ::slotted(cat-tab) {
  display: flex;
  flex: 1;
}

.cat-c-tabs--full-width .cat-c-tabs__header .cat-c-tabs__list {
  width: 100%;
}

::slotted(cat-tab) {
  display: block;
  flex-shrink: 0;
  padding: 0;
}
.cat-c-tabs-span-container ::slotted(cat-tab) {
  z-index: 1;
  position: relative;
}

.cat-c-tabs--responsive-full-width ::slotted(cat-tab) {
  /**
   * Tabs list within responsive full width tabs
   * 1) Make the tabs list expand full width on small screens
   */
}
@media all and (max-width: 35rem) {
  .cat-c-tabs--responsive-full-width ::slotted(cat-tab) {
    display: flex;
    flex: 1;
  }
}

/**
 * 1) List of selectable triggers that shows that trigger's relatable content when selected
 */
/**
 * Tabs header
 */
.cat-c-tabs__header {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /**
   * 1) Tabs inner where the beginning of the tabs list isn't fully in the viewport
   */
  /**
   * 1) Tabs inner where the end of the tabs list isn't fully in the viewport
   */
  /**
   * Tabs header within responsive full width tabs not start
   */
  /**
   * Tabs header within responsive full width tabs not end
   */
}
.cat-c-tabs:not(.cat-is-start) .cat-c-tabs__header {
  /**
   * Left overflow gradient for the overflow list
   */
}
.cat-c-tabs:not(.cat-is-start) .cat-c-tabs__header:before {
  content: "";
  display: block;
  position: absolute;
  pointer-events: none;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-default), rgba(255, 255, 255, 0.001) 30%);
  height: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: var(--cat-z-index-100);
}
.cat-c-tabs:not(.cat-is-end) .cat-c-tabs__header {
  /**
   * Right overflow gradient for the tabs list
   */
}
.cat-c-tabs:not(.cat-is-end) .cat-c-tabs__header:after {
  content: "";
  display: block;
  position: absolute;
  pointer-events: none;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), rgba(255, 255, 255, 0.001) 30%, var(--cat-theme-color-background-default));
  height: 100%;
  inset-block-start: 0;
  inset-inline-end: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: var(--cat-z-index-100);
}
@media all and (max-width: 35rem) {
  .cat-c-tabs--responsive-full-width:not(.cat-is-start) .cat-c-tabs__header {
    /**
     * Left overflow gradient for the tabs list within responsive full width variant
     * 1) Remove the shadows when the list is full width
     */
  }
  .cat-c-tabs--responsive-full-width:not(.cat-is-start) .cat-c-tabs__header:before {
    content: none;
  }
}
@media all and (max-width: 35rem) {
  .cat-c-tabs--responsive-full-width:not(.cat-is-end) .cat-c-tabs__header {
    /**
     * Right overflow gradient for the tabs list within responsive full width variant
     * 1) Remove the shadows when the list is full width
     */
  }
  .cat-c-tabs--responsive-full-width:not(.cat-is-end) .cat-c-tabs__header:after {
    content: none; /* 1 */
  }
}
@media all and (min-width: 35rem) {
  .cat-c-tabs__header {
    flex-direction: row;
    align-items: baseline;
  }
}

/**
 * Tabs list
 */
.cat-c-tabs__list {
  display: flex;
  overflow: auto;
  width: 100%;
  margin: calc(var(--size-base-unit) * 0.25) 0 calc(var(--size-base-unit) * 2) calc(var(--size-base-unit) * 0.25);
  position: relative;
  order: 2;
  /**
   * Tabs list within contrast control tabs
   */
  /**
   * Order 1 to place tabs after container after actual tabs on medium and large screens
   */
}
.cat-c-tabs--contrast .cat-c-tabs__list {
  width: fit-content;
  margin: 0;
  border-radius: var(--cat-border-radius-xl);
  background: var(--cat-theme-color-background-subtle);
}
@media all and (min-width: 35rem) {
  .cat-c-tabs__list {
    order: 1; /* 1 */
  }
}
.cat-c-tabs-span-container .cat-c-tabs__list:after {
  content: "";
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 1px;
  border-block-end: 1px solid var(--cat-theme-color-border-default);
}

/**
 * Tabs after
 * 1) Container that sits next to tabs on medium and large screens
 */
.cat-c-tabs__after {
  order: 1;
  margin-block-end: calc(var(--size-base-unit) * 2);
}
@media all and (min-width: 35rem) {
  .cat-c-tabs__after {
    order: 2;
    margin-inline-start: calc(var(--size-base-unit) * 2);
  }
}

/**
 * Tabs list item that is disabled
 */
.cat-c-tabs__item.cat-is-disabled {
  cursor: not-allowed;
}

/**
 * Tabs body
 * 1) Where the tabs panel sits
 */
.cat-c-tabs__body {
  text-align: start;
}

/**
* In Mobile view set width 100% so that tab list will occupy available width
*/
@media all and (max-width: 35rem) {
  .cat-c-tabs--responsive-full-width .cat-c-tabs__list {
    width: 100%;
  }
}
`;
       